import { pList, rValue } from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError } from '../../../../models/StateModels';
import { rOyakDegerlemeUstBilgi } from '../../../../api/models/rOyakDegerlemeUstBilgi';

export const action_async_start = (body: pList): IPromiseAction<pList> =>
  ActionFunctions.action_async_start_promise(
    ActionSubTypes.API_OYAKDEGERLEMEUSTBILGI,
    new Api.Bilgi.OyakDegerlemeUstBilgi().Request(body),
    false,
    false,
    body
  );

export const action_async_complete = (
  data: rValue<rOyakDegerlemeUstBilgi> | null | undefined,
  error: IError | null | undefined
): IApiAction<rOyakDegerlemeUstBilgi> =>
  ActionFunctions.action_async_complete_api<rOyakDegerlemeUstBilgi>(
    ActionSubTypes.API_OYAKDEGERLEMEUSTBILGI,
    data?.Value,
    error
  );
